var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 86,
    viewBox: "0 0 104 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.64 23.92C94.64 37.1306 73.4542 47.84 47.32 47.84C21.1858 47.84 0 37.1306 0 23.92C0 10.7094 21.1858 0 47.32 0C73.4542 0 94.64 10.7094 94.64 23.92ZM65.52 23.92C65.52 29.0894 57.3716 33.28 47.32 33.28C37.2684 33.28 29.12 29.0894 29.12 23.92C29.12 18.7506 37.2684 14.56 47.32 14.56C57.3716 14.56 65.52 18.7506 65.52 23.92Z",
    fill: "#D56B4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6569 44.5467C79.9764 45.9017 77.0113 46.8258 73.8398 47.8401C81.3223 47.9093 88.903 47.7927 94.6398 47.8401V35.2498C91.7029 38.9982 87.4478 42.1249 82.6569 44.5467Z",
    fill: "#9D4F39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.983 44.5467C7.19202 42.1249 2.93706 38.9982 0 35.2498V61.4069C0 67.9117 5.15663 73.8089 13.52 78.1145V72.8001C13.52 71.6513 14.4512 70.7201 15.6 70.7201C16.7488 70.7201 17.68 71.6513 17.68 72.8001V80.0177C22.5321 81.9875 28.1705 83.483 34.32 84.368V75.9201C34.32 74.7713 35.2512 73.8401 36.4 73.8401C37.5488 73.8401 38.48 74.7713 38.48 75.9201V84.8641C41.3438 85.1376 44.2988 85.2801 47.32 85.2801H57.2V76.9601C57.2 75.8113 58.1312 74.8801 59.28 74.8801C60.4288 74.8801 61.36 75.8113 61.36 76.9601V85.2801H81.12V76.9601C81.12 75.8113 82.0512 74.8801 83.2 74.8801C84.3488 74.8801 85.28 75.8113 85.28 76.9601V85.2801H98.801C101.672 85.2801 104 82.9515 104 80.0801V57.2001C104 54.3282 101.691 51.9975 98.8198 51.9759C80.9593 51.8407 63.1002 51.9446 45.24 52.0001C33.9585 52.0001 22.0567 49.639 11.983 44.5467Z",
    fill: "#9D4F39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.1022440170eb5ac65f1bca8eb3b31289.svg";
export { ForwardRef as ReactComponent };